/* tslint:disable */
/* eslint-disable */
/**
 * Profile API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { EmailTemplate } from './';
import {
    EmailTemplateFromJSON,
    EmailTemplateFromJSONTyped,
    EmailTemplateToJSON,
} from './';

/**
 * 
 * @export
 * @interface LanguageToEmailTemplatesInner
 */
export interface LanguageToEmailTemplatesInner {
    /**
     * 
     * @type {string}
     * @memberof LanguageToEmailTemplatesInner
     */
    language: string;
    /**
     * 
     * @type {EmailTemplate}
     * @memberof LanguageToEmailTemplatesInner
     */
    template: EmailTemplate;
}

/**
 * Check if a given object implements the LanguageToEmailTemplatesInner interface.
 */
export function instanceOfLanguageToEmailTemplatesInner(value: object): value is LanguageToEmailTemplatesInner {
    if (!('language' in value) || value['language'] === undefined) return false;
    if (!('template' in value) || value['template'] === undefined) return false;
    return true;
}

export function LanguageToEmailTemplatesInnerFromJSON(json: any): LanguageToEmailTemplatesInner {
    return LanguageToEmailTemplatesInnerFromJSONTyped(json, false);
}

export function LanguageToEmailTemplatesInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): LanguageToEmailTemplatesInner {
    if (json == null) {
        return json;
    }
    return {
        
        'language': json['language'],
        'template': EmailTemplateFromJSON(json['template']),
    };
}

export function LanguageToEmailTemplatesInnerToJSON(value?: LanguageToEmailTemplatesInner | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'language': value['language'],
        'template': EmailTemplateToJSON(value['template']),
    };
}

